import type { IconSvgObject } from './types';

const EuroCircleIcon: IconSvgObject = [
  ["path", { d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15.5 9.5C15 8.5 14.1936 8 13.1056 8C11.6665 8 10.5 9.16655 10.5 10.6056V13.3944C10.5 14.8335 11.6665 16 13.1056 16C14.1936 16 15 15.5 15.5 14.5M8.5 12H13.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default EuroCircleIcon;
